module.exports = __webpack_public_path__ + "static/media/hermione.6b04c07f.jpg";